import { useFormContext } from 'react-hook-form'

import { ContactFormDto } from '@/domains/contact/application/dto/createContact.dto'

export default function ContactSubmitButton() {
  const {
    formState: { isSubmitting },
  } = useFormContext<ContactFormDto>()

  return (
    <button
      type="submit"
      disabled={isSubmitting}
      className="group inline-flex w-full items-center justify-center gap-3 rounded-[3px] bg-chalk px-7 py-4 font-mono text-[0.6875rem] font-medium uppercase tracking-[0.16em] text-ink transition-colors duration-300 hover:bg-white disabled:cursor-not-allowed disabled:opacity-50"
    >
      {isSubmitting ? 'Envoi en cours...' : 'Envoyer'}
      {!isSubmitting && (
        <span
          aria-hidden="true"
          className="transition-transform duration-300 group-hover:translate-x-1"
        >
          &rarr;
        </span>
      )}
    </button>
  )
}
